type PropType = {
  chapters: { id: string; title: string }[];
  title: string;
};

const SurveyChapterIntroductionQuestion = ({ chapters, title }: PropType) => {
  const currentChapterIndex = chapters.findIndex(({ title: chapterTitle }) => chapterTitle === title);

  return (
    <ul className="chapter-list">
      {chapters.map(({ id, title: chapterTitle }, index) => {
        const classNames = ['chapter-item'];
        if (index < currentChapterIndex) {
          classNames.push('completed');
        } else if (index === currentChapterIndex) {
          classNames.push('current');
        }

        return (
          <li
            key={id}
            className={classNames.join(' ')}
          >
            {chapterTitle}
          </li>
        );
      })}
    </ul>
  );
};

export default SurveyChapterIntroductionQuestion;
